import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TargetIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule='evenodd'
          d="M9 7l4-7v4l3 3H9zm-1.5 5C5.567 12 4 10.433 4 8.5S5.567 5 7.5 5c.167 0 .327.026.488.049L7 9h3.95c-.245 1.694-1.688 3-3.45 3zm1.181-9.725l-.206.823C8.158 3.041 7.834 3 7.5 3 4.462 3 2 5.462 2 8.5S4.462 14 7.5 14c2.866 0 5.193-2.201 5.45-5h2c-.262 3.904-3.479 7-7.45 7C3.358 16 0 12.642 0 8.5 0 4.358 3.358 1 7.5 1c.501 0 .989.054 1.463.147l-.274 1.098-.008.03z"/> ]
  getViewBox = () => '0 0 16 16'
}
